module.exports = __webpack_public_path__ + "img/icn_profile.1fbd59e8.svg";